import { render, staticRenderFns } from "./FeedbackShotViewer.vue?vue&type=template&id=4d0dbbf9&scoped=true"
import script from "./FeedbackShotViewer.vue?vue&type=script&lang=ts"
export * from "./FeedbackShotViewer.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackShotViewer.vue?vue&type=style&index=0&id=4d0dbbf9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0dbbf9",
  null
  
)

export default component.exports